export const getRoutePath = (href) => {
  const parts = href.split('/')
  if (parts[3] === 'bookmarks')
    return `/${parts[3]}`
  return `/${parts[3]}/:slug`
}

export default getRoutePath
